import { Box, Typography, Divider, Link } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import EventIcon from "@mui/icons-material/Event";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ComingSoonSticker from "./Pictures/sticker-coming-soon.png";
import OpenNowSticker from "./Pictures/sticker-open-now.png";
import { useEffect, useState } from "react";
import { fromZonedTime } from "date-fns-tz";

function EventDetails() {
    const addressQuery =
        "Sovereign Rock Event Center, 5000 Western Center Blvd, Suite 340, Haltom City, TX 76137";
    const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
        addressQuery
    )}`;
    const [stickerToShow, setStickerToShow] = useState(null);
    const TIME_ZONE = "America/Chicago";
    const eventStartUTC = fromZonedTime( //original
        "2025-12-21 12:00:00",
        TIME_ZONE
    );
    const eventEndUTC = fromZonedTime( //original
        "2025-12-21 20:00:00",
        TIME_ZONE
    );

    // const eventStartUTCTest = fromZonedTime( //test
    //     "2025-12-20 06:45:00",
    //     TIME_ZONE
    // );

    // const eventEndUTCTest = fromZonedTime( //test
    //     "2025-12-20 06:50:00",
    //     TIME_ZONE
    // );

    const getEventStatus = (now = new Date()) => {
        if (now < eventStartUTC) {
            setStickerToShow(ComingSoonSticker)
        }
        else if (now >= eventStartUTC && now <= eventEndUTC) {
            setStickerToShow(OpenNowSticker)
        }
        else {
            setStickerToShow(null)
        }
    }

    useEffect(() => {
        let seconds = 0;
        const interval = setInterval(() => {
            seconds += 1;
            getEventStatus()
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    return (
        <Box
            sx={{
                maxWidth: { xs: "90%", sm: "80%", md: "70%", lg: "1200px" },
                width: "100%",
                mx: "auto",
                mt: 1,
                px: { xs: 3, md: 4 },
                py: { xs: 3, md: 4 },
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                gap: { xs: 3, md: 6 },
                background:
                    "linear-gradient(135deg, rgba(249,237,229,0.95), rgba(238,210,193,0.95))",
                borderRadius: 3,
                boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
                border: "1px solid rgba(193,155,130,0.35)",
                color: "#4e2f26",
                marginBottom: 5,
                position: "relative",
                overflow: "visible",
            }}
        >
            <Box sx={{ flex: 1, minWidth: 260 }}>
                <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 600, mb: 1, letterSpacing: 0.5, fontSize: 14 }}
                >
                    Event Details
                </Typography>

                <Divider sx={{ mb: 2, borderColor: "rgba(193,155,130,0.4)" }} />

                <Box sx={{ display: "flex", alignItems: "center", mb: 1, gap: 1 }}>
                    <AccessTimeIcon fontSize="medium" />
                    <Typography variant="body2" sx={{ fontSize: 12 }}>
                        12:00PM – 08:00PM
                    </Typography>
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <EventIcon fontSize="medium" />
                    <Typography variant="body2" sx={{ fontSize: 12 }}>
                        Sunday, 21 December 2025
                    </Typography>
                </Box>
            </Box>

            <Box sx={{ flex: 1, minWidth: 260 }}>
                <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 600, mb: 1, letterSpacing: 0.5, fontSize: 14 }}
                >
                    Location
                </Typography>

                <Divider sx={{ mb: 2, borderColor: "rgba(193,155,130,0.4)" }} />

                <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.2 }}>
                    <LocationOnIcon fontSize="medium" />

                    <Link
                        href={mapsUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        underline="hover"
                        sx={{ fontSize: 12, color: "inherit" }}
                        aria-label="Open address in Google Maps"
                    >
                        <Typography variant="body2" component="div" sx={{ fontSize: 12 }}>
                            Sovereign Rock Event Center
                            <br />
                            5000 Western Center Blvd
                            <br />
                            Suite 340
                            <br />
                            Haltom City, TX 76137
                        </Typography>
                    </Link>
                </Box>
            </Box>

            {stickerToShow && (
                <Box
                    component="img"
                    src={stickerToShow}
                    alt="Event status"
                    sx={{
                        position: "absolute",
                        top: { xs: 8, sm: 5, md: -10 },
                        right: { xs: 7, sm: 12, md: 3 },
                        width: { xs: 80, sm: 90, md: 135 },
                        height: "auto",
                        zIndex: 20,
                        pointerEvents: "none",
                    }}
                />
            )}
        </Box>
    );
}

export default EventDetails;


